<div class="root" *transloco="let t; read:'permit.requestFlammableAtexPermit'">
    <h1 class="root__heading">{{ t("heading") }}</h1>

    <ng-container *ngIf="(permitRequestSubmitted$ | async) === true || hasPendingPermitRequest; else requestForm">
        <div class="root__confirmation">
            <div class="root__confirmation__message">
                {{
                    permitRequestRecipientName
                        ? t("requestSentTo", { name: permitRequestRecipientName })
                        : t("requestSent")
                }}
            </div>

            <button
                class="root__confirmation__action"
                type="button"
                (click)="confirmRequestSent()"
                [disabled]="continueFlow && (loadingQuestion$ | async) === true">
                {{ continueFlow ? t("continue") : t("back") }}
            </button>
        </div>
    </ng-container>

    <ng-template #requestForm>
        <ng-container *ngIf="hasCheckedRequestStatus">
            <div class="root__loader" *ngIf="(loadingCandidates$ | async) === true"></div>

            <ng-container *ngIf="(loadingCandidates$ | async) !== true">
                <div class="root__list" *ngIf="candidates$ | async as candidates">
                    <div *ngIf="candidates.length === 0" class="root__empty">{{ t("empty") }}</div>

                    <div class="candidate" *ngFor="let candidate of candidates" (click)="toggleCandidate(candidate)">
                        <div class="candidate__details">
                            <div class="candidate__details__name">{{ candidate.fullName }}</div>
                            <div class="candidate__details__meta">{{ t("superintendentRole") }}</div>
                        </div>
                        <div class="candidate__checkmark"
                            [class.candidate__checkmark--selected]="(selectedCandidate$ | async)?.personId === candidate.personId">
                        </div>
                    </div>
                </div>

                <div class="root__error" *ngIf="errorMessage$ | async as errorMessage">{{ errorMessage }}</div>

                <div class="root__actions">
                    <button class="root__actions__cancel" type="button" (click)="cancel()">{{ t("back") }}</button>
                    <button
                        class="root__actions__request"
                        [class.root__actions__request--disabled]="(selectedCandidate$ | async) === undefined || (requestingPermit$ | async)"
                        [disabled]="(selectedCandidate$ | async) === undefined || (requestingPermit$ | async)"
                        type="button"
                        (click)="requestPermit()"
                    >
                        {{ t("request") }}
                    </button>
                </div>
            </ng-container>
        </ng-container>
    </ng-template>
</div>
